const styles = {
	wrapper: {
		a: {
			color: 'text',
			display: 'block',
			textDecoration: 'none',
			textAlign: 'center',
		},
		img: {
			borderRadius: '6px',
		},
		h3: {
			color: 'primary',
			fontWeight: 600,
			fontSize: '16px',
			lineHeight: '1.25',
			marginTop: '10px',
		},
		p: {
			fontSize: '15px',
			lineHeight: '1.6',
		},
	},
};

export default styles;
